// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-38ed449c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.top-right-btn[data-v-38ed449c] {\n  margin-bottom: 10px;\n}\n@media (max-width: 550px) {\n.flex[data-v-38ed449c] {\n    display: block;\n}\n}", ""]);
// Exports
module.exports = exports;
